module.exports = __webpack_public_path__ + "static/dine-in-4cee2121c36013527f60f55994b1e679.png";